import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { AdminManageState } from "models/adminManage";

const initialState: AdminManageState = {
  profileloading: false,
  loading: false,
  data: {},
  customerListData: [],
  customerListSuccess: false,
  customerListMessage: "",
  message: "",
  success: false,
  profileUrl: "",
  updateMessage: "",
  addAdminUserMessage: "",
  addAdminUserLoading: false,
  updateAdminUserMessage: "",
  updateAdminUserLoading: false,
  brandListData: [],
  brandListSuccess: false,
  brandListMessage: false,
  deleteLoading: false,
  deleteMessage: "",
  customerListLoading: false,
  storeListData: [],
  storeListDataLoading: false,
  storeListDataMessage: "",
  storeListDataSuccess: false,
  roleListLoading: false,
  roleListMessage: "",
  roleListData: [],
  adminUserByIdLoading: false,
  adminUserByIdSuccess: false,
  adminUserByIdData: {},
};

const adminManageSlice = createSlice({
  name: "adminUserMgmtAdminUsers",
  initialState,
  reducers: {
    getAdminUsers(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getAdminUsersSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getAdminUsersFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getAdminUserById(state, action: PayloadAction<ApiResponse>) {
      state.adminUserByIdLoading = true;
      state.adminUserByIdSuccess = false;
    },
    getAdminUserByIdSuccess(state, action: PayloadAction<any>) {
      state.adminUserByIdLoading = false;
      state.adminUserByIdData = action.payload?.data;
      state.adminUserByIdSuccess = action.payload.success;
    },
    getAdminUserByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.adminUserByIdLoading = false;
      state.adminUserByIdData = {};
      state.adminUserByIdSuccess = action.payload.success;
    },
    addAdminUser(state, action: PayloadAction<ApiResponse>) {
      state.addAdminUserLoading = true;
      state.addAdminUserMessage = "";
    },
    addAdminUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addAdminUserLoading = false;
      state.addAdminUserMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addAdminUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.addAdminUserLoading = false;
      state.addAdminUserMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAdminUser(state, action: PayloadAction<ApiResponse>) {
      state.updateAdminUserLoading = true;
      state.updateAdminUserMessage = "";
    },
    updateAdminUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateAdminUserLoading = false;
      state.updateAdminUserMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAdminUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateAdminUserLoading = false;
      state.updateAdminUserMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAdminUser(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteAdminUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAdminUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    getStoreList(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = true;
      state.storeListDataMessage = "";
    },
    getStoreListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = false;
      state.storeListData = action.payload.storeName;
      state.storeListDataSuccess = action.payload.success;
    },
    getStoreListFailed(state, action: PayloadAction<ApiResponse>) {
      state.storeListDataLoading = false;
      state.storeListDataMessage = action.payload.message;
      state.storeListDataSuccess = action.payload.success;
    },
    getImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = true;
      state.profileUrl = "";
    },
    getImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = false;
      state.profileUrl = action.payload.photoURL;
    },
    getImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = false;
      state.profileUrl = "";
    },
    getRoleList(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = true;
      state.profileUrl = "";
    },
    getRoleListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = false;
      state.roleListData = action.payload.roleModuleData;
    },
    getRoleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.profileloading = false;
      state.profileUrl = "";
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.addAdminUserLoading = false;
      state.addAdminUserMessage = "";
      state.updateMessage = "";
      state.deleteMessage = "";
      state.profileUrl = "";
      state.updateAdminUserMessage = "";
      state.updateAdminUserLoading = false;
      state.deleteMessage = "";
      state.deleteLoading = false;
      state.storeListDataSuccess = false;
      state.storeListDataMessage = "";
    },
  },
});

//Actions
export const adminUserMgmtAdminUsersActions = adminManageSlice.actions;

//Selectors
export const getAdminUsersListData = (state: RootState) =>
  state.adminUserMgmtAdminUsers.data;
export const getAdminUserById = (state: RootState) =>
  state.adminUserMgmtAdminUsers.adminUserByIdData;
export const getAdminListDataLoad = (state: RootState) =>
  state.adminUserMgmtAdminUsers.loading;
export const addAdminIsLoading = (state: RootState) =>
  state.adminUserMgmtAdminUsers.addAdminUserLoading;
export const addAdminIsMessage = (state: RootState) =>
  state.adminUserMgmtAdminUsers.addAdminUserMessage;
export const CustomerListData = (state: RootState) =>
  state.document.customerListData;
export const BrandListData = (state: RootState) => state.document.brandListData;
export const StoreListData = (state: RootState) =>
  state.adminUserMgmtAdminUsers.storeListData;
export const updateAdminUserMessage = (state: RootState) =>
  state.adminUserMgmtAdminUsers.updateAdminUserMessage;
export const updateAdminUserLoading = (state: RootState) =>
  state.adminUserMgmtAdminUsers.updateAdminUserLoading;
export const deleteAdminUserLoad = (state: RootState) =>
  state.adminUserMgmtAdminUsers.deleteLoading;
export const deleteAdminUserMsg = (state: RootState) =>
  state.adminUserMgmtAdminUsers.deleteMessage;
export const brandListData = (state: RootState) =>
  state.brandLocation.brandListData;
export const profileLoading = (state: RootState) =>
  state.adminUserMgmtAdminUsers.profileloading;
export const profileUrlBack = (state: RootState) =>
  state.adminUserMgmtAdminUsers.profileUrl;
export const getUserRoleList = (state: RootState) =>
  state.adminUserMgmtAdminUsers.roleListData;

//Reducers
const adminManageReducer = adminManageSlice.reducer;
export default adminManageReducer;
